import { normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["type", "placeholder", "value", "disabled"]
const _hoisted_2 = ["type", "placeholder", "value", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["form-group form-group-block", [ _ctx.disabled ? 'disabled' : '', _ctx.borderClass ]])
  }, [
    (!_ctx.isEditor)
      ? _withDirectives((_openBlock(), _createElementBlock("input", {
          key: 0,
          class: _normalizeClass(["form-control", _ctx.inputClass]),
          autofocus: "",
          type: _ctx.type,
          placeholder: _ctx.placeholder,
          value: _ctx.modelValue,
          onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateInput && _ctx.updateInput(...args))),
          disabled: _ctx.disabled
        }, null, 42, _hoisted_1)), [
          [_directive_maska, _ctx.mask]
        ])
      : _createCommentVNode("", true),
    (_ctx.isEditor)
      ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
          key: 1,
          class: _normalizeClass(["form-control", _ctx.inputClass]),
          autofocus: "",
          type: _ctx.type,
          placeholder: _ctx.placeholder,
          value: _ctx.modelValue,
          onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateInput && _ctx.updateInput(...args))),
          disabled: _ctx.disabled
        }, null, 42, _hoisted_2)), [
          [_directive_maska, _ctx.mask]
        ])
      : _createCommentVNode("", true)
  ], 2))
}